import React from "react";
import styled from "@emotion/styled";

const Svg = styled.svg<{ checked: boolean }>`
  height: 70%;
  width: 70%;
  margin: 15%;
  transition: 166ms transform ease-in-out;
  transform: scale(0);

  ${(props) => (props.checked ? `transform: scale(1);` : "")}
`;

type CheckmarkProps = {
  checked?: boolean;
};

export function Checkmark({ checked }: CheckmarkProps) {
  return (
    <Svg
      checked={checked}
      width="100%"
      height="100%"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.526.253L3.28 5.506 1.473 3.703a.863.863 0 10-1.22 1.223l2.418 2.412a.863.863 0 001.22-.002l5.857-5.863A.863.863 0 008.526.253z"
        fill="#05727a"
      />
    </Svg>
  );
}
